module.exports = __webpack_public_path__ + "static/img/pic_system_upgrade.e9226f0.png";


//////////////////
// WEBPACK FOOTER
// ./static/staticPages/pic_system_upgrade.png
// module id = 9yMv
// module chunks = 83